module.exports = __webpack_public_path__ + "img/level_one.2083b176.png";